export enum NotificationType {
    PENDING_RECEIVED_TRANSFERS = 0,
}
